import type { ReactElement } from "react";
import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useUnmount } from "app/custom-hooks/useUnmount";
import { TabbedPageContent } from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import findAppsTrackingService from "app/pages/sales-intelligence/modules/find-apps-filters/services/tracking/trackingService";
import {
    resetFindAppsState,
    setActiveAppSourceType,
} from "app/pages/sales-intelligence/store/find-apps/action-creators";
import { selectActiveAppSourceType } from "app/pages/sales-intelligence/store/find-apps/selectors";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";

import { tabsConfig } from "../configuration/tabsConfig";
import useTabsData from "../hooks/useTabsData";

const FindAppsContentContainer = (): ReactElement => {
    const dispatch = useDispatch();

    const activeAppSourceType = useSelector(selectActiveAppSourceType);

    useTabsData();

    const handleTabSelect = useCallback((tabId: AppsSourceType): void => {
        dispatch(setActiveAppSourceType(tabId));
    }, []);

    const handleTabClick = useCallback((tabId: AppsSourceType): void => {
        findAppsTrackingService.trackTabChange(tabId);
    }, []);

    useUnmount(() => {
        dispatch(resetFindAppsState());
    });

    return (
        <TabbedPageContent<AppsSourceType, PageTabBase<AppsSourceType>>
            tabs={tabsConfig}
            selectedTabId={activeAppSourceType}
            onTabSelect={handleTabSelect}
            onTabClick={handleTabClick}
        />
    );
};

export default FindAppsContentContainer;
